import { Injectable } from '@angular/core';
import { SlackWebhookService } from '../slack-webhook.service';

import { Observable } from 'rxjs/Observable';

import { environment } from '../../environments/environment';

import { Contact } from './contact';

@Injectable()
export class ContactService {

    constructor(private slackService: SlackWebhookService) {
    }

    newContactRequest(contact: Contact): Observable<string> {
        return this.slackService.hitWebhook(environment.slackApiContactWebHook, `
*Incoming contact*
${contact.name.trim()}<${contact.email.trim()}> says the following:
${contact.body.trim()}
        `.trim());
    }
}



// WEBPACK FOOTER //
// /Users/tom/Projects/mercit2018/src/app/contact/contact.service.ts